import {
  runBuyAutoLaunchTicketCommand,
  runBuyAutoLaunchUpgradeCommand,
  runToggleAutoExtendCommand,
  runUseAutoLaunchTicketCommand
} from "../auto-launch/commands";
import type { AutoLaunchUpgradeKind } from "../auto-launch/catalog";
import type { ProfileProgress } from "../progression/levels";
import type { AutoLaunchTicketSeconds, OrbitForgeSave } from "../save/types";
import type { FeedbackDraft } from "./feedback";

export type AutoLaunchRuntimeCommand =
  | { readonly type: "buy-auto-ticket"; readonly seconds: AutoLaunchTicketSeconds }
  | { readonly type: "use-auto-ticket"; readonly seconds: AutoLaunchTicketSeconds }
  | { readonly type: "buy-auto-upgrade"; readonly kind: AutoLaunchUpgradeKind }
  | { readonly type: "toggle-auto-extend" };

export interface AutoLaunchRuntimeCommandResult {
  readonly dirty: boolean;
  readonly feedback: readonly FeedbackDraft[];
}

export function runAutoLaunchRuntimeCommand(
  save: OrbitForgeSave,
  progress: ProfileProgress,
  command: AutoLaunchRuntimeCommand
): AutoLaunchRuntimeCommandResult {
  if (command.type === "buy-auto-ticket") {
    return runBuyAutoLaunchTicketCommand(save, progress, command.seconds);
  }

  if (command.type === "use-auto-ticket") {
    return runUseAutoLaunchTicketCommand(save, progress, command.seconds);
  }

  if (command.type === "buy-auto-upgrade") {
    return runBuyAutoLaunchUpgradeCommand(save, progress, command.kind);
  }

  return runToggleAutoExtendCommand(save, progress);
}
